import * as HTMLElementCreator from '../../../libs/HTML/HTMLElementCreator';
import { LABEL_STYLE } from '../EditorOverlayStyles';

export interface EditorCheckBox {
  panel: HTMLElement;
  label: HTMLElement;
  checkBox: HTMLInputElement;
}

export interface EditorCheckBoxConfig {
  parentElement: HTMLElement;
  labelText: string;
  onValueChanged: (checked: boolean) => void;
  initialValue: boolean;
  panelStyle?: Partial<CSSStyleDeclaration>;
  inputStyle?: Partial<CSSStyleDeclaration>;
  labelStyle?: Partial<CSSStyleDeclaration>;
}

export function createEditorCheckBox({
  parentElement,
  labelText,
  onValueChanged,
  initialValue,
  inputStyle = {},
  labelStyle = {},
  panelStyle = {},
}: EditorCheckBoxConfig): EditorCheckBox {
  const panel = HTMLElementCreator.createDiv({
    parentElement,
    style: { ...panelStyle },
  });

  const label = HTMLElementCreator.createLabel({
    parentElement: panel,
    style: { ...LABEL_STYLE, ...labelStyle },
    labelText,
  });

  const checkBox = HTMLElementCreator.createCheckBox({
    parentElement: panel,
    onChange: onValueChanged,
    style: { ...inputStyle },
  });
  checkBox.checked = initialValue;

  return { panel, label, checkBox };
}
